
<p-dialog #editorDialog [(visible)]="editorVisible" [style]="{width:'75%', height:'75%'}">
    <div class="flex grid w-full h-full">
        <div class="flex grid col-12" style="min-height: 90%; height:90%">
            <div class="flex col-4 flex-column h-full">
                <p-card class="flex flex-column h-full w-full" styleClass="flex flex-column h-full w-full"  header="Original Charges">
                    <div class="flex h-full w-full flex-column">
                        <div class="flex w-full align-items-center justify-content-center text-6xl" style="min-height: 20%;">{{medicalBill().totalCharges | currency}}</div>
                        <div *ngIf="!this.activeAdjustment" class="flex flex-column w-full" style="min-height: 50%;">
                            <p-panel >
                                <ng-template pTemplate="header">
                                    <div class="flex flex-row gap-2 w-full align-items-center">
                                        <div>Adjustment</div>
                                        <div><p-selectButton class="flex w-full" (onChange)="adjustmentOptionChange($event)" [options]="adjustmentOptions" [allowEmpty]="false" [(ngModel)]="selectedAdjustmentOption"></p-selectButton></div>
                                    </div>
                                </ng-template>  
                                <div class="flex align-items-center justify-content-center w-full flex-column">
                                    <div *ngIf="selectedAdjustmentOption=='Existing'" class="flex w-full"><p-listbox [(ngModel)]="selectedExistingAdjustment" [options]="availableProviderDiscounts" optionLabel="displayName" class="flex w-full" styleClass="flex w-full" (onChange)="adjustmentChanged()"></p-listbox></div>
                                    <div *ngIf="selectedAdjustmentOption=='Custom'" class="flex align-items-center justify-content-center w-full flex-column">
                                        <custom-amount [(customAmount)]="customAmount" (onValueChange)="adjustmentChanged()" ></custom-amount>
                                    </div>

                                </div>
                            </p-panel>
                        </div>
                        <div  style="min-height: 30%;">
                            <div *ngIf="!activeAdjustment && this.potentialAdjustement">
                                <div class="flex w-full align-items-center justify-content-center text-xl">Potential Adjusted Bill Amount</div>
                                <div class="flex grid w-full">
                                    <div class="col-3"></div>
                                    <div class="flex col-6 align-items-center justify-content-center text-6xl">{{this.potentialAdjustement.totalAdjustedAmount| currency}}</div>
                                    <div class="flex col-3 align-items-center justify-content-center"><p-button size="small" (onClick)="adjustmentOverlay.toggle($event)" icon="pi pi-list" rounded/></div>
                                        <p-overlayPanel #adjustmentOverlay>
                                            <div>
                                                <p-table [value]="potentialAdjustement.lines" class="p-datatable-sm">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Units</th>
                                                            <th>Original Amount</th>
                                                            <th>Adjustment</th>
                                                            <th>Adjusted Amount</th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-adjustment>
                                                        <tr>
                                                            <td>{{adjustment.code}} <p-tag *ngIf="adjustment.separateProcedure" rounded severity="warning" icon="pi pi-exclamation-triangle"  pTooltip="Separate Procedure"  /></td>
                                                            <td>{{adjustment.units}}</td>
                                                            <td>{{adjustment.originalPrice | currency}}</td>
                                                            <td>{{adjustment.adjustment | currency}}</td>
                                                            <td>{{adjustment.adjustedPrice | currency}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </p-overlayPanel>
                                    </div>

                                    <div class="flex w-full align-items-center justify-content-center"><p-button [disabled]="activeAdjustment" (onClick)="confirmAdjustment()">Confirm</p-button></div>
                                
                            </div>
                            <div *ngIf="activeAdjustment">
                                <div class="flex w-full align-items-center justify-content-center"><p-button [disabled]="activeAdjustment.activeRepricing" (onClick)="voidAdjustment()">Undo Adjustment</p-button></div>
                            </div>
                        </div>

                    </div>
                    
                    
                    
                </p-card>
            </div>
            <div class="flex col-4 flex-column h-full">
                <p-card class="flex flex-column h-full w-full" styleClass="flex flex-column h-full w-full" header="Adjusted Charges">
                    <div class="flex w-full align-items-center justify-content-center text-6xl" style="min-height: 20%;">
                        <span *ngIf="activeAdjustment">{{activeAdjustment.totalAdjustedAmount | currency}}</span>
                        <span *ngIf="!activeAdjustment">N/A</span>
                    </div>
                    <div *ngIf="!this.activeRepricing && this.activeAdjustment" class="flex flex-column w-full" style="min-height: 50%;">
                            <p-panel>
                                <ng-template pTemplate="header">
                                    <div class="flex flex-row gap-2 w-full align-items-center">
                                        <div>Repricing</div>
                                        <div><p-selectButton (onChange)="repriceOptionChange($event)" [options]="repriceOptions" [allowEmpty]="false" [(ngModel)]="selectedRepriceOption"></p-selectButton></div>
                                    </div>
                                </ng-template>  
                                <div class="flex align-items-center justify-content-center w-full flex-column">
                                    <div *ngIf="selectedRepriceOption=='Existing'" class="flex w-full"><p-listbox [(ngModel)]="selectedExistingMarkup" [options]="availableProviderMarkups" optionLabel="displayName" class="flex w-full" styleClass="flex w-full" (onChange)="repricingChanged()"></p-listbox></div>
                                    <div *ngIf="selectedRepriceOption=='Custom'" class="flex align-items-center justify-content-center w-full flex-column">
                                        <custom-amount [(customAmount)]="customRepricing" (onValueChange)="repricingChanged()" ></custom-amount>
                                    </div>
                                    
                                    
                                </div>
                            </p-panel>
                        </div>
                        <div  style="min-height: 30%;">
                            <div *ngIf="!activeRepricing && this.potentialRepricing">
                                <div class="flex w-full align-items-center justify-content-center text-xl">Potential Repriced Bill Amount</div>
                                <div class="flex grid w-full">
                                    <div class="col-3"></div>
                                    <div class="flex col-6 align-items-center justify-content-center text-6xl">{{this.potentialRepricing.totalRepricedAmount| currency}}</div>
                                    <div class="flex col-3 align-items-center justify-content-center"><p-button size="small" (onClick)="repricingOverlay.toggle($event)" icon="pi pi-list" rounded/></div>
                                    <p-overlayPanel #repricingOverlay>
                                        <div>
                                            <p-table [value]="potentialRepricing.lines" class="p-datatable-sm">
                                                <ng-template pTemplate="header">
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>Units</th>
                                                        <th>Basis Amount</th>
                                                        <th>Markup</th>
                                                        <th>Repriced Amount</th>
                                                    </tr>
                                                </ng-template>
                                                <ng-template pTemplate="body" let-repricing>
                                                    <tr>
                                                        <td>{{repricing.code}}  <p-tag *ngIf="repricing.separateProcedure" rounded severity="warning" icon="pi pi-exclamation-triangle"  pTooltip="Separate Procedure"  /></td>
                                                        <td>{{repricing.units}}</td>
                                                        <td>{{repricing.originalPrice | currency}}</td>
                                                        <td>{{repricing.totalMarkup | currency}}</td>
                                                        <td>{{repricing.repricedAmount | currency}}</td>
                                                    </tr>
                                                </ng-template>
                                            </p-table>
                                        </div>
                                    </p-overlayPanel>
                                </div>
                                <div class="flex w-full align-items-center justify-content-center"><p-button [disabled]="activeRepricing" (onClick)="confirmRepricing()">Confirm</p-button></div>
                                
                                
                            </div>
                            <div *ngIf="activeRepricing">
                                <div class="flex w-full align-items-center justify-content-center"><p-button (onClick)="voidRepricing()">Undo Repricing</p-button></div>
                            </div>
                        </div>
                </p-card>
            </div>
            <div class="flex col-4 flex-column h-full">
                <p-card class="flex flex-column h-full w-full" styleClass="flex flex-column h-full w-full" header="Repriced Charges">
                    <div class="flex w-full align-items-center justify-content-center text-6xl" style="min-height: 20%;">
                        <span *ngIf="activeRepricing">{{activeRepricing.totalRepricedAmount| currency}}</span>
                        <!-- <span *ngIf="repricing">Gain: {{repricing.gain| currency}}</span> -->
                        <span *ngIf="!activeRepricing">N/A</span>
                    </div>
                </p-card>
            </div>
        </div>
        <div class="col-4"></div>
        <div class="flex col-4 flex-column align-items-center justify-content-center">
            <p-buttonGroup>
                <p-button [disabled]="!activeRepricing" label="Lock" icon="pi pi-check" (onClick)="lockBill()"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="editorVisible = false"></p-button>
            </p-buttonGroup>
        </div>
        <div class="col-4 flex align-items-center justify-content-center">
            <a [href]="HEMILink" target="_blank">View Encounter in HEMI</a>
        </div>
    </div>
</p-dialog>



<!-- <p-card> -->
<div class="grid">
    <div class="col-12" class="col-12 align-items-center">
        <div class="flex grid">
            <div class="flex grid col-12 align-items-center p-2 ">
                <!-- <div class="flex col-6 align-items-center "> -->
                    <div class="flex flex-column col-9">
                        <div>{{getTitleSection()}}</div>
                        <div>{{this.medicalBill().servicingProvider.facility.name}} - {{this.medicalBill().totalCharges | currency}}</div>
                        <div>{{this.medicalBill().category.categoryName}} {{this.medicalBill().serviceBegin | date:'shortDate'}}</div>
                        <div>Submitted: {{this.medicalBill().submissionDate | date:'short'}}</div>
                    </div>
                    <div class="flex flex-row col-3 gap-1">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" [raised]="true" (onClick)="startEditing()"></p-button>
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" [raised]="true" (onClick)="deleteBill()"></p-button>

                    </div>
                    <div class="flex grid col-12">

                        <div class="flex col-3 flex-column align-items-center justify-content-center">
                            <div>Adjusted</div>
                            <div><span *ngIf="activeAdjustment">{{activeAdjustment.totalAdjustedAmount | currency}}</span>  <span *ngIf="!activeAdjustment">N/A</span></div>
                        </div>
                        <div class="flex col-3 flex-column align-items-center justify-content-center">
                            <div>Repriced</div>
                            <div><span *ngIf="activeRepricing">{{activeRepricing.totalRepricedAmount| currency}}</span>  <span *ngIf="!activeRepricing">N/A</span></div>
                        </div>
                        <div class="flex col-3 flex-column align-items-center justify-content-center">
                            <div>Gain</div>
                            <div><span *ngIf="activeRepricing">{{activeRepricing.gain| currency}}</span>  <span *ngIf="!activeRepricing">N/A</span></div>
                        </div>
                        <div class="flex col-3 flex-column align-items-center justify-content-center">
                            <div>Submitted</div>
                            <div><span *ngIf="activeRepricing?.submittedToPayer">Yes</span><span *ngIf="!activeRepricing?.submittedToPayer">No</span></div>
                            <div *ngIf="activeRepricing?.payerSubmissionDate">{{activeRepricing?.payerSubmissionDate | date:'short'}}</div>
                        </div>                        
                    </div>

            </div>
                <!-- </div> -->
                <!-- <div class="flex col-3 align-items-center">
                    <p-button *ngIf="(draftMedicalBill() != undefined)" icon="pi pi-search" [rounded]="true" [text]="true" [raised]="true" (onClick)="startEditing()"></p-button>
                </div>
                <div class="flex col-3 align-items-center">
                    <span *ngIf="(draftMedicalBill() == undefined)"><p-button [disabled]="isProcessing$ | async" [icon]="!(isProcessing$ | async) ? 'pi pi-refresh' : 'pi pi-spin pi-spinner'" [rounded]="true" [text]="true" [raised]="true" (onClick)="refreshButtonPressed()"> </p-button></span>
                    <span *ngIf="medicalBill != undefined">
                        <span *ngIf="allowSave()"><i class="pi pi-check p-2 border-2 border-circle" style="background-color: green; color:white; fill:white"></i></span>
                        <span *ngIf="!allowSave() && formErrorCount > 0 && medicalBill.allProcessingErrors.length == 0"><i class="pi pi-exclamation-triangle text-4xl" style="color:orange; fill:orange" pBadge [value]="formErrorCount"></i></span>
                        <span *ngIf="!allowSave() && medicalBill.allProcessingErrors.length > 0"><i class="pi pi-exclamation-circle text-4xl" style="color:red; fill:red" pBadge [value]="medicalBill.allProcessingErrors.length"></i></span>

                    </span>
                </div>
                <div class="flex col-12 justify-content-center">
                    <span>{{submissionStatus$ | async}}</span>
                </div> -->
        </div>
        
    </div>
</div>
<!-- </p-card> -->